import { type Surface, filterBySurface } from '@capture/shared';

export interface JobTab {
  id: string;
  label: string;
  /** SP1 §5.1 — absent = visible on both surfaces. */
  surfaces?: readonly Surface[];
}

export const AUTOMATIONS_TAB: JobTab = { id: 'automations', label: 'Automations' };

/** SP6 Task 3 — Remittance job-config tab. Surface-gated: only visible on
 *  remittance-surface jobs, so standard jobs never see it (filterBySurface
 *  drops it via the `surfaces` discriminator). */
export const REMITTANCE_TAB: JobTab = { id: 'remittance', label: 'Remittance', surfaces: ['remittance'] };

/**
 * SP1 — generalizes the P3c withAutomationsTab seam: appends the (still
 * unconditional) Automations tab, then filters the whole strip by the job's
 * surface. With zero declared remittance tabs this is behavior-identical to
 * the old helper for standard jobs — pinned by tests.
 *
 * SP6 — also appends REMITTANCE_TAB (before AUTOMATIONS_TAB), gated to the
 * remittance surface. Standard jobs are unaffected (REMITTANCE_TAB is
 * filtered out); remittance jobs get it as the second-to-last tab.
 */
export function visibleTabsFor(base: readonly JobTab[], surface: Surface): JobTab[] {
  return filterBySurface([...base, REMITTANCE_TAB, AUTOMATIONS_TAB], surface);
}
